import { RangePicker } from '@/components/common/range-picker'
import { ButtonCheckbox } from '@/components/main/contests/button-select'
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Checkbox } from '@/components/ui/checkbox'
import { AwardIcon } from 'lucide-react'

interface RewardAccordionProps {
  setPrizeNumberMin: (min: number | null) => void
  setPrizeNumberMax: (max: number | null) => void
  certificate: boolean
  trophy: boolean
  internship: boolean
  publishWork: boolean
  companyPartnership: boolean
  setCertificate: (value: boolean) => void
  setTrophy: (value: boolean) => void
  setInternship: (value: boolean) => void
  setPublishWork: (value: boolean) => void
  setCompanyPartnership: (value: boolean) => void
  isPrizeSliderActive: boolean
  setIsPrizeSliderActive: (active: boolean) => void
  isBooleanOptionActive: boolean
  setIsBooleanOptionActive: (active: boolean) => void
}

export function RewardAccordion({
  setPrizeNumberMin,
  setPrizeNumberMax,
  certificate,
  trophy,
  internship,
  publishWork,
  companyPartnership,
  setCertificate,
  setTrophy,
  setInternship,
  setPublishWork,
  setCompanyPartnership,
  isPrizeSliderActive,
  setIsPrizeSliderActive,
  isBooleanOptionActive,
  setIsBooleanOptionActive,
}: RewardAccordionProps) {
  return (
    <AccordionItem value="item-5">
      <div className="mb-2">
        <AccordionTrigger>
          <div className="flex h-[10px] items-center gap-2 px-3 text-[12px]">
            <AwardIcon className="text-[12px]" />
            <p>รางวัล</p>
          </div>
        </AccordionTrigger>
      </div>
      <div className="px-5">
        <AccordionContent>
          <div className="flex items-center space-x-2">
            <Checkbox
              id="reward"
              checked={isPrizeSliderActive}
              onCheckedChange={(checked) =>
                setIsPrizeSliderActive(checked as boolean)
              }
            />
            <label
              htmlFor="reward"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              จำนวนเงินรางวัล
            </label>
          </div>
          {/* Slider */}
          <RangePicker
            defaultMin={0}
            defaultMax={500_000}
            step={1}
            onChange={(values) => {
              setPrizeNumberMin(values.min ?? 0)
              setPrizeNumberMax(values.max ?? 500_000)
            }}
            isActive={isPrizeSliderActive}
            className="w-[337px] py-4"
          />
          <div className="flex items-center space-x-2">
            <Checkbox
              id="other"
              checked={isBooleanOptionActive}
              onCheckedChange={(checked) => {
                setIsBooleanOptionActive(checked as boolean)
                if (!checked) {
                  setCertificate(false)
                  setTrophy(false)
                  setInternship(false)
                  setPublishWork(false)
                  setCompanyPartnership(false)
                }
              }}
            />
            <label
              htmlFor="terms"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              โอกาสอื่นๆ
            </label>
          </div>
          <div className="py-4">
            <div className="space-y-2">
              <div className="flex w-full flex-wrap gap-2">
                <ButtonCheckbox
                  checked={certificate}
                  onCheckedChange={(checked) => {
                    setCertificate(checked)
                  }}
                  size="sm"
                  disabled={!isBooleanOptionActive}
                >
                  <span>เกียรติบัตร</span>
                </ButtonCheckbox>
                <ButtonCheckbox
                  checked={trophy}
                  onCheckedChange={(checked) => {
                    setTrophy(checked)
                  }}
                  size="sm"
                  disabled={!isBooleanOptionActive}
                >
                  <span>เหรียญ / โล่ รางวัล</span>
                </ButtonCheckbox>
                <ButtonCheckbox
                  checked={publishWork}
                  onCheckedChange={(checked) => {
                    setPublishWork(checked)
                  }}
                  size="sm"
                  disabled={!isBooleanOptionActive}
                >
                  <span>เผยแพร่ผลงาน</span>
                </ButtonCheckbox>
                {/* <ButtonCheckbox
                checked={internship}
                onCheckedChange={(checked) => {
                  setInternship(checked)
                }}
                size="sm"
                disabled={!isBooleanOptionActive}
              >
                <span>ต่อยอดผลงาน</span>
              </ButtonCheckbox> */}
                {/* <ButtonCheckbox
                // handleSelect={() => {
                //   // setCompanyPartnership(!companyPartnership)
                // }}
                size="sm"
                disabled={!isBooleanOptionActive}
              >
                <span>เข้าร่วมกิจกรรมเครือข่าย</span>
              </ButtonCheckbox> */}
                <ButtonCheckbox
                  checked={internship}
                  onCheckedChange={(checked) => {
                    setInternship(checked)
                  }}
                  size="sm"
                  disabled={!isBooleanOptionActive}
                >
                  <span>ฝึกงาน</span>
                </ButtonCheckbox>
                <ButtonCheckbox
                  checked={companyPartnership}
                  onCheckedChange={(checked) => {
                    setCompanyPartnership(checked)
                  }}
                  size="sm"
                  disabled={!isBooleanOptionActive}
                >
                  <span>ร่วมงานกับบริษัท</span>
                </ButtonCheckbox>
                {/* <ButtonCheckbox
                // handleSelect={() => {
                //   // setCertificate(!certificate)
                // }}
                size="sm"
                disabled={!isBooleanOptionActive}
              >
                <span>เวิร์กชอป / คอร์สพิเศษ</span>
              </ButtonCheckbox> */}
              </div>
            </div>
          </div>
        </AccordionContent>
      </div>
    </AccordionItem>
  )
}
